function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainPowerBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.98 29.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m24.62,4.73v24.08H.36V.36h24.25v4.38M3.14,20.02v-9.21m0-4.42v-3.93h18.76v24.3H3.14v-2.32m1.02-13.62H2v-4.44h2.16v4.44Zm-1.12,13.62h-1.04v-4.42h2.16v4.42h-1.12Zm4.52-3.58h9.89m-9.89,2.39h9.89m-4.78-12.63l-.87,2.7,1.21-.04-.99,2.48m6.13,1.13l-.69.7H7.18l-.51-.52,5.83-10.76,5.66,10.58h0Zm2.02-5.64v-3.72m0-2.62v-.82m0,2.56v-.82",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeMiterlimit: 10,
      strokeWidth: ".72px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPowerBoard);
export default __webpack_public_path__ + "static/media/MainPowerBoard.79294e3610cef6777ee3a9205337d6b9.svg";
export { ForwardRef as ReactComponent };